/* eslint camelcase: "off" */
import React from "react"
import PropTypes from "prop-types"
import {
  FormContainer,
  InputField,
  StandardModal,
  BirthDatePicker,
  stateOptions
} from "uikit"
import { Grid, Form, Dropdown, Button } from "semantic-ui-react"

const CheckboxButton = ({ value, onChange }) => (
  <Button.Group
    floated="right"
    style={{ clear: "both" }}
    data-testid="marritalStatus"
  >
    <Button
      type="button"
      primary
      basic={value !== "single"}
      floated="right"
      onClick={e => onChange(e, { value: "single" })}
    >
      Single
    </Button>
    <Button
      type="button"
      primary
      basic={value !== "married"}
      floated="right"
      onClick={e => onChange(e, { value: "married" })}
    >
      Married
    </Button>
  </Button.Group>
)

const SpouseDetails = ({ spouse }) => (
  <Grid>
    <Grid.Row columns={1}>
      <Grid.Column style={{ backgroundColor: "#d7d7d7" }}>
        <span>SPOUSE</span>
      </Grid.Column>
    </Grid.Row>
    <Grid.Row columns={2} style={{ padding: "0rem" }}>
      <Grid.Column>
        <InputField
          field={spouse.fields.first_name}
          label="Spouse's First Name"
          className="AddModal__FormField"
          data-testid="spouseFirstName"
        />
      </Grid.Column>
      <Grid.Column>
        <InputField
          field={spouse.fields.birth_date}
          label="Birth Date"
          control={BirthDatePicker}
          className="AddModal__FormField"
          dataName="spouseBirthDate"
        />
      </Grid.Column>
    </Grid.Row>
  </Grid>
)

const ChildrenNumberSelector = ({ number, onChange }) => (
  <div>
    <Button.Group size="mini">
      {[...Array(4).keys()].map(key => (
        <Button
          type="button"
          key={key}
          primary
          basic={number !== key}
          floated="right"
          onClick={e => onChange(key)}
          data-testid={`numChildren/${key}`}
          style={{
            borderRadius: key > 0 ? "0px" : "1.125em 0px 0px 1.125em",
            borderLeftStyle: "none"
          }}
        >
          {key}
        </Button>
      ))}
    </Button.Group>
    <input
      placeholder="More"
      min="1"
      type="number"
      style={{
        width: "5.2em",
        height: "1.9em",
        borderTopRightRadius: "1.125em",
        borderBottomRightRadius: "1.125em",
        border: "solid 1px  #0caae9",
        borderLeft: "none",
        paddingBottom: "0px",
        paddingTop: "0px"
      }}
      onBlur={e => onChange(e.target.value)}
    />
  </div>
)

const ChildrenDetails = ({ children_details }) => (
  <Grid>
    <Grid.Row columns={1}>
      <Grid.Column style={{ backgroundColor: "#d7d7d7" }}>
        <span>CHILDREN</span>
      </Grid.Column>
    </Grid.Row>
    <Grid.Row columns={1}>
      <Grid.Column>
        <InputField
          field={children_details}
          label="Number of Dependent Children"
          number={children_details.array.length}
          control={ChildrenNumberSelector}
          onChange={number => {
            let arrayLength = children_details.array.length
            let diff = number - arrayLength
            let step = Math.sign(diff) * -1
            while (diff !== 0) {
              step === 1
                ? children_details.array[--arrayLength].remove()
                : children_details.append()
              diff += step
            }
          }}
        />
      </Grid.Column>
    </Grid.Row>
    {children_details.array.length > 0 && (
      <Grid.Row columns={2} style={{ padding: "0rem", color: "#ababab" }}>
        <Grid.Column>
          <span>First Name</span>
        </Grid.Column>
        <Grid.Column>
          <span>Birth Date</span>
        </Grid.Column>
      </Grid.Row>
    )}
    {children_details.array.map((child, index) => (
      <Grid.Row
        key={index}
        columns={2}
        style={{ padding: "0rem" }}
        className="Children__Row"
      >
        <Grid.Column>
          <InputField
            field={child.fields.first_name}
            className="AddModal__FormField"
          />
        </Grid.Column>
        <Grid.Column>
          <InputField
            field={child.fields.birth_date}
            control={BirthDatePicker}
            className="AddModal__FormField"
          />
        </Grid.Column>
      </Grid.Row>
    ))}
  </Grid>
)

const SetupHouseholdForm = ({
  data: {
    fields: {
      first_name,
      birth_date,
      primary_state_of_residence,
      marital_status,
      spouse,
      children_details
    },
    isModified,
    onSubmit,
    isPending,
    hasError,
    error
  },
  submitLabel = "Add This Person",
  submitHeader = "",
  onCancel
}) => (
  <Form error={hasError} loading={isPending} className="AddModal__Form">
    <Grid className="setupHousehold" stackable>
      <Grid.Row columns={2} style={{ padding: "0rem" }}>
        <Grid.Column>
          <InputField
            field={first_name}
            label="Your First Name"
            className="AddModal__FormField"
            data-testid="firstName"
          />
        </Grid.Column>
        <Grid.Column>
          <InputField
            field={birth_date}
            label="Birth Date"
            control={BirthDatePicker}
            className="AddModal__FormField"
            data-testid="birthDate"
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns={2} style={{ padding: "0rem" }}>
        <Grid.Column>
          <InputField
            field={primary_state_of_residence}
            className="AddModal__FormField"
            placeholder="State"
            label="State of Residence"
            fluid
            selection
            control={Dropdown}
            options={stateOptions}
            search={(options, query) => {
              return options.filter(option =>
                option.text.toLowerCase().startsWith(query.toLowerCase())
              )
            }}
            data-testid="state"
          />
        </Grid.Column>
        <Grid.Column>
          <InputField
            field={marital_status}
            className="AddModal__FormField"
            label="Marital Status"
            control={CheckboxButton}
          />
        </Grid.Column>
      </Grid.Row>
      {marital_status.value === "married" && (
        <Grid.Row columns={1}>
          <Grid.Column>
            <SpouseDetails spouse={spouse} />
          </Grid.Column>
        </Grid.Row>
      )}
      <Grid.Row columns={1}>
        <Grid.Column>
          <ChildrenDetails children_details={children_details} />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  </Form>
)

const SetupHouseholdFormModal = props => {
  // Ugly, but working hack

  // https://github.com/Semantic-Org/Semantic-UI-React/issues/1759
  // PR Says fixed but, not fixed.
  const bodyTag = document.querySelector("body")
  // If IE?
  if (!!window.MSInputMethodContext && !!document.documentMode) {
    bodyTag.classList.add("dimmable")
    bodyTag.classList.add("dimmed")
    bodyTag.classList.add("scrolling")
  }
  return (
    <StandardModal defaultOpen={true} closeOnDimmerClick={false} wide>
      <StandardModal.Header
        header="Household Profile"
        subHeader="Telling us about your household will help us ask the right questions and make it easier for you to get organized"
      />
      <StandardModal.Content>
        <SetupHouseholdForm {...props} />
      </StandardModal.Content>
      <StandardModal.Actions
        submitLabel="Continue"
        cancelLabel="Cancel"
        onSubmit={props.data.onSubmit}
        onCancel={props.onCancel}
        loading={props.data.isPending}
      />
    </StandardModal>
  )
}

export const SetupHousehold_SCHEMA = {
  first_name: {
    type: "string",
    required: true
  },
  birth_date: {
    type: "birthdate",
    required: true
  },
  primary_state_of_residence: {
    type: "string",
    required: true
  },
  marital_status: {
    type: "string",
    required: false,
    defaultValue: "single"
  },
  spouse: {
    type: "object",
    schema: {
      first_name: {
        type: "string",
        required: false
      },
      birth_date: {
        type: "birthdate",
        required: false
      }
    }
  },
  children_details: {
    type: "array",
    minLength: 0,
    schema: {
      first_name: {
        type: "string",
        required: false,
        isMuted: false
      },
      birth_date: {
        type: "birthdate",
        required: false,
        isMuted: false
      }
    }
  }
}

export const SetupHouseholdModal = FormContainer(
  SetupHousehold_SCHEMA,
  ({ fields }) => {
    const {
      spouse: {
        fields: {
          first_name: { value: spouse_name },
          birth_date: { value: spouse_birth_date }
        }
      },
      marital_status: { value: marital_status },
      children_details: { array: children }
    } = fields

    // Forgot to add spouse detail
    if (marital_status === "married") {
      if (!spouse_name) {
        return {
          fields: {
            "spouse/first_name": "This is required"
          }
        }
      }
      if (!spouse_birth_date) {
        return {
          fields: {
            "spouse/birth_date": "This is required"
          }
        }
      }
    }

    // Forgot to enter child name / birthdate
    if (children.length > 0) {
      // Invalid or illegitimate kids? :S
      let invalidChildren = children.filter(
        ({ fields: { first_name, birth_date } }) =>
          !first_name.value || !birth_date.value
      )
      if (invalidChildren.length > 0) {
        let childrenErrorObject = invalidChildren.reduce((acl, curr) => {
          // Which fields the user forgot to fill
          let invalidFields =
            Object.keys(curr.fields).filter(
              field => !curr.fields[field].value
            ) || []
          // We could also hard-code ${curr.name} since we know which field is this
          // also index is available in reduce() fn.
          let fields = invalidFields.reduce(
            (a, b) =>
              Object.assign({}, a, {
                [`${curr.name}/${b}`]: "This is required"
              }),
            {}
          )
          // Since we're creating the "fields" object, don't forget to
          // copy the previous iteration's "fields" object.
          // took ~10 minutes to figure this out.
          Object.assign(fields, acl.fields || {})
          return Object.assign({}, acl, {
            fields
          })
        }, {})
        return childrenErrorObject
      }
    }
  }
)(SetupHouseholdFormModal)

SetupHouseholdModal.PropTypes = {
  submit: PropTypes.func,
  onCancel: PropTypes.func
}
